import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import IconCompound from '@/ui/fonts/compound.svg?react';
import IconTransporter from '@/ui/fonts/transporter.svg?react';
import IconShortTransporter from '@/ui/fonts/short_transporter.svg?react';
import IconBell from '@/ui/fonts/notification-bell.svg?react';
import { Tooltip } from 'antd';

export enum Icons {
  compound = 'compound',
  transporter = 'transporter',
  shortTransporter = 'shortTransporter',
  bell = 'bell',
}

export type IconProps = {
  icon: IconDefinition | Icons;
  scale?: number;
  color?: string;
  [key: string]: any;
};

export const Icon: FC<IconProps> = ({ icon, scale, color, ...props }) => {
  if (icon === Icons.compound) {
    return <IconCompound width="45px" height="40px" {...props} />;
  }

  if (icon === Icons.transporter) {
    return <IconTransporter width="45px" height="40px" {...props} />;
  }

  if (icon === Icons.shortTransporter) {
    return <IconShortTransporter width="45px" height="40px" {...props} />;
  }

  if (icon === Icons.bell) {
    return <IconBell width="45px" height="40px" {...props} />;
  }

  return (
    <FontAwesomeIcon
      icon={icon as IconProp}
      size={scale ? (`${scale}x` as SizeProp) : undefined}
      color={color}
      {...props}
    />
  );
};

export const TooltipIcon: FC<IconProps> = ({ title, ...props }) => {
  return (
    <Tooltip title={title}>
      <Icon className="hoverable-icon" {...props} aria-label={title} />
    </Tooltip>
  );
};
